import type { FctFamilia } from '../../fct/react/componentes/semantica';
import type { FctNombreIcono } from '../../fct/react/iconos';

// Los estados de una propuesta (FC_C_ESTADO_TRANSMISION) con su familia del semáforo y su icono: el color nunca va solo.
const ESTADOS: Record<number, { etiqueta: string; familia: FctFamilia; icono: FctNombreIcono }> = {
  0: { etiqueta: 'En venta', familia: 'proceso', icono: 'transmision' },
  1: { etiqueta: 'Sin notificar', familia: 'aviso', icono: 'hora' },
  2: { etiqueta: 'Notificada', familia: 'aviso', icono: 'correo' },
  3: { etiqueta: 'Pendiente', familia: 'aviso', icono: 'hora' },
  5: { etiqueta: 'Realizada', familia: 'exito', icono: 'completado' },
};

export const estadoAlta = (estadoId: number) =>
  ESTADOS[estadoId] ?? { etiqueta: `Estado ${estadoId}`, familia: 'neutro' as FctFamilia, icono: 'punto' as FctNombreIcono };

/** Las reglas de la API (#325): qué puede hacer el asesor según el estado. */
export const reglasEstado = (estadoId: number) => ({
  editar: estadoId >= 0 && estadoId <= 2,
  vendida: estadoId === 0,
  borrar: estadoId === 0,
  notificar: estadoId === 1 || estadoId === 2,
});
